import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLID,
  GraphQLNonNull
} from 'graphql'
import { dateTimeType, DateTime } from './date-time-type'

export interface StigTemplateDetail {
  readonly name: string
  readonly created: DateTime
}

export const stigTemplateDetail = new GraphQLObjectType({
  name: 'StigTemplateDetail',
  fields: () => ({
    name: {
      description: 'File name of the template',
      type: new GraphQLNonNull(GraphQLID)
    },
    created: {
      description: 'The date the template was uploaded',
      type: new GraphQLNonNull(dateTimeType)
    }
  })
})

export interface StigTemplate {
  readonly name: string
  readonly fileType: string
  readonly content: string
}

export const stigTemplate = new GraphQLObjectType({
  name: 'StigTemplate',
  fields: () => ({
    name: {
      description: 'File name of the template',
      type: new GraphQLNonNull(GraphQLID)
    },
    fileType: {
      description: 'The file type of the template (e.g. CSV, CKL)',
      type: new GraphQLNonNull(GraphQLString)
    },
    content: {
      description: 'The tempkate file content',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
